<template>
  <div>
    <swiper :options="swiperOption" v-if="swiperList.length > 0" id="swiper">
      <swiperSlide v-for="(item, index) in swiperList" :key="index">
        <img :src="item" class="swiper" />
      </swiperSlide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      swiperList: [],
      swiperOption: {
        autoplay: { delay: 3000, disableOnInteraction: false },
        delay: 5000,
        loop: true,
        preventClicks: false,
        preventClicksPropagation: false,
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http.get("/setting/open").then(res => {
        this.swiperList = res.data.data[0].bannerUrl;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper {
  width: 100%;
  height: 500px;
}
.swiper-pagination-bullet {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
  cursor: pointer;
  border: 2px solid #979797;
  transition: all 0.05s ease-in;
}
.ubolt-black {
  background: #0e0e0e;
}
.ubolt-white {
  background: #d8d8d8;
}
</style>
